import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from 'uuid';
// import { reportSlice } from './../../redux/reducers/report';

const todosSlice = createSlice({
  name: "todo",
  initialState: {
    todoList:   [
      { id: 1, content: "Hit the gym", isDone: false },
      { id: 2, content: "Meet George", isDone: false}
    ]
  },
  reducers: {
    addTodo(state, action) {
      const newTask = {
        id: uuidv4,
        content: action.payload.todo,
        isDone: false,
      };
      state.todoList.push(newTask);
    },
    deleteTask: (state, action) => {
      return state.filter((item) => item.id !== action.payload.id);
    },
    setIsDoneTask: (state, action) => {
      let { todoList } = state;
      state.todoList = todoList.map((item) => 
        item.id === action.payload.id ? action.payload.isDone = true : item);
    }
  },
});

export const { addTodo, deleteTask, setIsDoneTask } = todosSlice.actions;

export default todosSlice.reducer;
